<template>
  <vx-card
    :class="[
      'overflow-hidden statistics-card',
      `statistics-card-${type}`
    ]"
  >
    <template slot="no-body">
      <div class="p-4">
        <div class="flex items-center justify-between">
          <div class="flex-1 min-w-0">
            <p
              class="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1"
            >
              {{ title }}
            </p>
            <h2 :class="[
              valueSize === 'large' ? 'text-2xl' : 'text-xl',
              'font-bold text-gray-900 leading-tight'
            ]">
              {{ formattedValue }}
            </h2>
            <p class="text-xs text-gray-500 mt-1">
              {{ description }}
            </p>
          </div>
          <div
            class="flex-shrink-0 ml-3 p-2 rounded-full"
            :style="iconBackgroundStyle"
          >
            <feather-icon
              :icon="icon"
              :class="iconClass"
              size="18"
            />
          </div>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
export default {
  name: 'DashboardStatisticsCard',
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'success', 'warning', 'danger', 'info'].includes(value)
    },
    icon: {
      type: String,
      required: true
    },
    iconColor: {
      type: String,
      default: null, // Se null, usa a mesma cor do type
      validator: value => !value || ['primary', 'success', 'warning', 'danger', 'info'].includes(value)
    },
    valueSize: {
      type: String,
      default: 'large', // 'large' para text-2xl, 'small' para text-xl
      validator: value => ['large', 'small'].includes(value)
    },
    formatter: {
      type: Function,
      default: null // Função para formatar o valor (ex: formatCurrency, formatNumber)
    }
  },
  computed: {
    formattedValue() {
      if (this.formatter) {
        return this.formatter(this.value)
      }
      return this.value
    },
    iconClass() {
      const color = this.iconColor || this.type
      return `text-${color}`
    },
    iconBackgroundStyle() {
      const colorMap = {
        primary: 'rgba(115, 103, 240, 0.15)',
        success: 'rgba(40, 199, 111, 0.15)',
        warning: 'rgba(255, 159, 67, 0.15)',
        danger: 'rgba(234, 84, 85, 0.15)',
        info: 'rgba(0, 207, 232, 0.15)'
      }
      
      const color = this.iconColor || this.type
      const bgColor = colorMap[color] || colorMap.primary
      
      return `background: linear-gradient(135deg, ${bgColor} 0%, ${bgColor.replace('0.15', '0.25')} 100%);`
    }
  }
}
</script>

<style scoped>
.statistics-card {
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.statistics-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.statistics-card-primary {
  border-left-color: #7367f0;
}

.statistics-card-success {
  border-left-color: #28c76f;
}

.statistics-card-warning {
  border-left-color: #ff9f43;
}

.statistics-card-danger {
  border-left-color: #ea5455;
}

.statistics-card-info {
  border-left-color: #00cfe8;
}

/* Melhorar legibilidade dos valores */
.statistics-card h2 {
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.statistics-card p {
  line-height: 1.5;
}
</style>

